import React from 'react';

const Logout: React.FC = () => {
  return (
    <h1>Logout</h1>
  )
}

export default Logout;